import { create } from '@bufbuild/protobuf';
import { MCPSchema, MCPTransport, type MCP } from '@/proto/agentplatform/v1/mcp_pb';

export interface MCPInstanceFormState {
  id?: string;
  name: string;
  description: string;
  serverUrl: string;
  transport: MCPTransport;
  headers: Array<{ key: string; value: string }>;
  skipTlsVerify: boolean;
  timeoutSeconds: number;
}

export const emptyMCPInstanceForm: MCPInstanceFormState = {
  name: '',
  description: '',
  serverUrl: '',
  transport: MCPTransport.MCP_TRANSPORT_STREAMABLE_HTTP,
  headers: [],
  skipTlsVerify: false,
  timeoutSeconds: 0,
};

export function fromMCP(mcp: MCP): MCPInstanceFormState {
  return {
    id: mcp.id,
    name: mcp.name,
    description: mcp.description,
    serverUrl: mcp.serverUrl,
    transport: mcp.transport,
    headers: Object.entries(mcp.headers || {}).map(([key, value]) => ({ key, value })),
    skipTlsVerify: mcp.skipTlsVerify,
    timeoutSeconds: mcp.timeoutSeconds,
  };
}

export function toMCP(form: MCPInstanceFormState): MCP {
  const headers: Record<string, string> = {};
  for (const { key, value } of form.headers) {
    if (key.trim()) headers[key.trim()] = value;
  }
  return create(MCPSchema, {
    id: form.id,
    name: form.name.trim(),
    description: form.description,
    serverUrl: form.serverUrl.trim(),
    transport: form.transport,
    headers,
    skipTlsVerify: form.skipTlsVerify,
    timeoutSeconds: Math.max(0, Math.floor(form.timeoutSeconds || 0)),
  });
}

export function isMCPInstanceFormValid(form: MCPInstanceFormState): boolean {
  return !!form.name.trim() && !!form.serverUrl.trim();
}
